import React from 'react';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './LandingPage.css';

const LandingPage = () => {
  const { t } = useTranslation();
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: true
  };

  // Carousel images - add your photos to public/images/ folder
  // Name them: carousel-1.jpg, carousel-2.jpg, carousel-3.jpg (or .png)
  const carouselImages = [
    {
      id: 1,
      src: '/images/carousel-1.jpg',
      alt: 'Opera singer performance',
      //title: t('landing.title1')
    },
    {
      id: 2,
      src: '/images/carousel-2.png',
      alt: 'Opera singer in costume',
      //title: t('landing.title2')
    },
    {
      id: 3,
      src: '/images/carousel-3.jpg',
      alt: 'Opera singer portrait',
      //title: t('landing.title3')
    }
  ];

  return (
    <div className="landing-page">
      <div className="carousel-container">
        <Slider {...settings}>
          {carouselImages.map((image) => (
            <div key={image.id} className="carousel-slide">
              <div 
                className="slide-image"
                style={{ backgroundImage: `url(${image.src})` }}
              >
                <div className="slide-overlay">
                  <div className="slide-content">
                    <h1 className="slide-title">{image.title}</h1>
                    <p className="slide-subtitle">{t('landing.subtitle')}</p>
                    <p className="slide-description">{t('landing.description')}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default LandingPage;
